import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RemoveIcon = ({ fill = 'red', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
        >
            <title>Remove Icon</title>
            <path
                className={fillStyles}
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm6 11.5H6a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1z"
            />
        </svg>
    );
};
